<div id="w4formContainer">
  <h2 class="formTitle">W-4 Form</h2>
  <span>
    This form lets us know how much money to withhold from your paycheck for federal income taxes.
    Accurately completing this form can ensure you don't have a big balance due at tax time.
    <br />
    It can also prevent you from overpaying your taxes, putting more money in your pocket during the
    year. For reference, view the IRS Form W-4.
  </span>

  <div *ngIf="driverW4Update">
    <p-accordion [multiple]="true">
      <p-accordionTab header="Step 1: Personal Information" [selected]="true">
        <div class="flex-list">
          <div class="flex-item-col flex-item-30">
            <p style="white-space: nowrap">First Name and Middle Initial</p>
            <input
              #firstName="ngModel"
              [(ngModel)]="driverW4Update.firstName"
              pInputText
              required="true"
              type="text"
            />
            <div
              *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="firstName.errors.required">
                <span>First Name and Middle Initial is required.</span>
              </div>
            </div>
          </div>
          <div class="flex-item-col flex-item-30">
            <p>Last Name</p>
            <input
              #lastName="ngModel"
              [(ngModel)]="driverW4Update.lastName"
              pInputText
              type="text"
              required="true"
            />
            <div
              *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="lastName.errors.required">
                <span>Last Name is required.</span>
              </div>
            </div>
          </div>
          <div class="flex-item-col flex-item-30">
            <p>Social Security Number</p>
            <input disabled="true" [(ngModel)]="driverW4Update.ssn" pInputText type="text" />
          </div>
        </div>
        <div class="flex-list">
          <div class="flex-item-col flex-item-20">
            <p>Address Line 1</p>
            <input
              #address1="ngModel"
              [(ngModel)]="driverW4Update.address.line1"
              pInputText
              required="true"
              type="text"
            />
            <div
              *ngIf="address1.invalid && (address1.dirty || address1.touched)"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="address1.errors.required">
                <span>Address Line 1 is required.</span>
              </div>
            </div>
          </div>

          <div class="flex-item-col flex-item-20">
            <p>Address Line 2</p>
            <input [(ngModel)]="driverW4Update.address.line2" pInputText type="text" />
          </div>
          <div class="flex-item-col flex-item-20">
            <p>City</p>
            <input
              #city="ngModel"
              [(ngModel)]="driverW4Update.address.city"
              pInputText
              required="true"
              type="text"
            />

            <!-- <label>City</label>
            <cre-input-text
              errorMessage="Please enter a valid city."
              formControlName="city"
              [invalid]="isInvalidFormField('city')"
              placeholder="Enter your city"
              [showClear]="true"
              type="text"
            ></cre-input-text> -->
          </div>

          <div
            *ngIf="city.invalid && (city.dirty || city.touched)"
            class="alert alert-danger alert-danger-custom"
          >
            <div *ngIf="city.errors.required">
              <span>City is required.</span>
            </div>
          </div>
          <div class="flex-item-col flex-item-20">
            <p>State</p>
            <p-dropdown
              [style]="{ minWidth: '172px', width: '100%' }"
              #addresState="ngModel"
              [filter]="true"
              [(ngModel)]="driverW4Update.address.state"
              [options]="states"
              (onChange)="loadStateStatus()"
              placeholder="Select a State"
              required="true"
            ></p-dropdown>
            <!-- <label>State</label>
            <p-dropdown
              formControlName="state"
              optionLabel="label"
              [options]="stateOptions"
              optionValue="value"
              placeholder="Enter your state"
              [styleClass]="'dropdown'"
            ></p-dropdown> -->
            <div
              *ngIf="addresState.errors && (addresState.dirty || addresState.touched)"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="addresState.errors.required">
                <span>State is required.</span>
              </div>
            </div>
          </div>
          <div class="flex-item-col flex-item-20">
            <p>Zip</p>
            <input
              maxlength="5"
              minlength="5"
              [(ngModel)]="driverW4Update.address.zip"
              (blur)="zipCodeSearch(true)"
              (input)="filterZip($event)"
              pInputText
              placeholder="00000"
              pattern="^[0-9]{5}$"
              type="text"
              required
              #zip="ngModel"
            />
            <div
              *ngIf="(zip.invalid && (zip.dirty || zip.touched)) || zipsize"
              class="alert alert-danger alert-danger-custom"
            >
              <span *ngIf="zipsize">Valid Zip code is required.</span>
              <div *ngIf="zip.errors.required">
                <span>Zip is required.</span>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div class="p-grid">
          <div class="p-col-12">
            <p>Federal Withholding Status*</p>
            <div class="ui-g form-control">
              <div class="ui-g-12" style="line-height: 25px">
                <p-radioButton
                  class="form-control"
                  [disabled]="driverW4Update.federalInfo.isExempt"
                  label="Single
                  or Married filing separately"
                  name="federalWithholdingStatus"
                  [(ngModel)]="driverW4Update.federalInfo.withHoldingStatus"
                  required="true"
                  value="SINGLE"
                >
                </p-radioButton>
                <br />
                <p-radioButton
                  class="form-control"
                  [disabled]="driverW4Update.federalInfo.isExempt"
                  label="Married filing jointly (or Qualifying widow(er))"
                  name="federalWithholdingStatus"
                  [(ngModel)]="driverW4Update.federalInfo.withHoldingStatus"
                  required="true"
                  value="MARRIED"
                >
                </p-radioButton>
                <br />
                <p-radioButton
                  class="form-control"
                  [disabled]="driverW4Update.federalInfo.isExempt"
                  label="Head
                  of household (Check only if you’re unmarried and pay more
                  than half the costs of keeping up a home for yourself and a
                  qualifying individual.)"
                  name="federalWithholdingStatus"
                  [(ngModel)]="driverW4Update.federalInfo.withHoldingStatus"
                  required="true"
                  value="HEAD"
                >
                </p-radioButton>
                <p>* Federal Withholding Status Notes:</p>
                <ul>
                  <li>Single or Married filing separately = 2 Exemptions</li>
                  <li>Married filing jointly = 3 Exemptions</li>
                  <li>Head of Household = 2 Exemptions</li>
                  <li>For 0 exemptions check the box Under Step #2</li>
                </ul>
              </div>
              <div
                *ngIf="
                  !driverW4Update.federalInfo.isExempt &&
                  driverW4Update.federalInfo.withHoldingStatus === ''
                "
                class="alert alert-danger alert-danger-custom"
              >
                <span>Federal Withholding Status is required.</span>
              </div>
            </div>
            <hr />
            <div class="p-col">
              <span class="p-fluid">
                <p-checkbox
                  binary="true"
                  label="Exempt from Withholding"
                  name="groupname"
                  [(ngModel)]="driverW4Update.federalInfo.isExempt"
                  (onChange)="disableSection($event)"
                ></p-checkbox>
              </span>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <p>
              <b>Exemption from withholding.</b> To claim exempt from with holdings check the box
              above. See page 2 of
              <a href="http://www.irs.gov/pub/irs-pdf/fw4.pdf" id="w4Link" target="_blank"
                >the IRS Form W-4</a
              >
              for more information on who can claim exemption from withholding. Then, complete Steps
              1 and 5. Do not complete any other steps. You will need to submit a new Form W-4 by
              February 15th.
            </p>
            <hr />

            <p>Complete Steps 2-4 ONLY if you have any of the following:</p>
            <ul>
              <li>Multiple jobs OR filing jointly and spouse also works</li>
              <li>
                Children to claim for <u><b>CHILD TAX CREDIT</b></u> or other qualifying dependents
                or other eligible tax credits
              </li>
              <li>Other deductions or taxable income you would like to withhold for</li>
            </ul>
            <p>
              OTHERWISE SKIP TO STEP 5. See page 2 of the
              <a href="http://www.irs.gov/pub/irs-pdf/fw4.pdf" id="w4Link" target="_blank"
                >the IRS Form W-4</a
              >
              for more information on each step, when to use the on-line estimator, and privacy.
            </p>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Step 2: Multiple Jobs or Spouse Works">
        <div class="step2">
          <div class="row1">
            <p>
              <b
                >Complete this step if you (1) hold more than one job at a time, or (2) are married
                filing jointly and your spouse also works. The correct amount of withholding depends
                on income earned from all of these jobs.</b
              >
            </p>
          </div>
          <div class="row2">
            <p>Do <b> ONLY ONE </b> of the following.</p>
          </div>
          <div class="row3 margin-left">
            <b>(a)</b> Use the estimator at www.irs.gov/W4App for most accurate withholding for this
            step (and Steps 3–4);
            <b>or</b>
          </div>
          <div class="row4 margin-left">
            (b) Use the Multiple Jobs Worksheet on page 3 and enter the result in Step 4(c) below
            for roughly accurate withholding; <b>or</b>
          </div>

          <div class="row5 margin-left">
            (c) If there are only two jobs total, you may check this box. Do the same on Form W-4
            for the other job. This option is accurate for jobs with similar pay; otherwise, more
            tax than necessary may be withheld.
          </div>
          <div class="row5 col2">
            <span>
              <b>2(c) . . . . . . . . . .</b>
            </span>
          </div>
          <div class="row5 col3">
            <fa-icon [icon]="faCaretRight"></fa-icon>
          </div>
          <div class="row5 col4">
            <p-checkbox
              [binary]="true"
              class="p-col"
              [disabled]="driverW4Update.federalInfo.isExempt"
              name="sencodJobIndicator"
              [(ngModel)]="driverW4Update.federalInfo.twoJobsTotal"
            ></p-checkbox>
          </div>
          <div class="row6">
            <p>
              <b>TIP:</b> To be accurate, submit a Form W-4 for all other jobs. If you (or your
              spouse) have self-employment income, including as an independent contractor, use the
              estimator.
            </p>
            <br />
          </div>
          <div class="row7">
            <p>
              <b>Complete Steps 3–4(b) on Form W-4 for only ONE of these jobs.</b>
              Leave those steps blank for the other jobs. (Your withholding will be most accurate if
              you complete Steps 3–4(b) on the Form W-4 for the highest paying job.)
            </p>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Step 3: Claim Dependents">
        <div class="step3">
          <div class="row1">
            <b
              >Complete Step 3 <u>ONLY</u> if you have children to claim CHILD TAX CREDIT on your
              tax return, or other qualifying dependents or credits, and if your income will be less
              than $200,000 (or $400,000 or less if married filling jointly)</b
            >
          </div>

          <div class="row2 col1 margin-left">
            <div class="p-col-12 p-md-12 p-lg-6">
              <div class="p-grid">
                <div class="p-col">
                  <p># of qualifying children under the age 17</p>
                </div>
                <div class="p-col">
                  <p># of other dependents</p>
                </div>
              </div>
              <div class="p-grid">
                <div class="p-col">
                  <span class="p-fluid">
                    <input
                      (change)="qualifiedChildrenChanged()"
                      [(disabled)]="driverW4Update.federalInfo.isExempt"
                      [(ngModel)]="driverW4Update.federalInfo.qualifiedChildrenCount"
                      min="0"
                      oninput="this.value=
                      !!this.value && Math.abs(this.value)>= 0 ?
                    Math.abs(this.value): null"
                      pInputText
                      type="number"
                    />
                  </span>
                </div>
                <div class="p-col">
                  <span class="p-fluid">
                    <input
                      (change)="otherDependantChanged()"
                      [(disabled)]="driverW4Update.federalInfo.isExempt"
                      min="0"
                      oninput="this.value=
                      !!this.value && Math.abs(this.value)>= 0 ?
                    Math.abs(this.value): null"
                      type="number"
                      pInputText
                      [(ngModel)]="driverW4Update.federalInfo.otherDependentsCount"
                    />
                  </span>
                </div>
              </div>
            </div>
            Multiply the number of qualifying children under age 17 by $2,000:
            <input
              [disabled]="true"
              [(ngModel)]="driverW4Update.federalInfo.qualifiedChildrenAmount"
              min="0"
              oninput="this.value=
              !!this.value && Math.abs(this.value)>= 0 ? Math.abs(this.value):
            null"
              pInputText
              placeholder="$0.00"
              style="width: 100px"
              type="number"
            />
          </div>
          <div class="row3 col1 margin-left">
            Multiply the number of other dependents by $500:
            <input
              [disabled]="true"
              mask="$999.99"
              [(ngModel)]="driverW4Update.federalInfo.otherDependentsAmount"
              pInputText
              placeholder="$0.00"
              style="width: 100px"
              type="text"
            />
          </div>
          <div class="row4 col1">Add the amounts above and enter the total here</div>
          <div class="row4 col2">
            <span><b>3 . . . . . . . . .</b></span>
          </div>
          <div class="row4 col3">
            <fa-icon [icon]="faCaretRight"></fa-icon>
          </div>
          <div class="row4 col4">
            <span class="p-fluid">
              <input
                [disabled]="true"
                [(ngModel)]="driverW4Update.federalInfo.totalClaimAmount"
                pInputText
                placeholder="$0.00"
                type="text"
              />
            </span>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Step 4: Other Adjustments (optional)">
        <div class="step4">
          <div class="info row1">
            If you have any questions with 4(a) or 4(b), please call payroll at 1-800-897-1801,
            option 3.
          </div>
          <div class="step4a row2">
            <p>
              <b>(a) Other income (not from jobs).</b>&nbsp;If you want tax withheld for other
              income you expect this year that won’t have withholding, enter the amount of other
              income here. This may include interest, dividends, and retirement income
            </p>
          </div>
          <div class="row2 col2">
            <span><b>4(a) . . . . . . . .</b></span>
          </div>
          <div class="row2 col3">
            <fa-icon [icon]="faCaretRight"></fa-icon>
          </div>
          <div class="row2 col4">
            <span class="p-fluid">
              <input
                [disabled]="true"
                [(ngModel)]="driverW4Update.federalInfo.otherIncomeAmount"
                min="0"
                oninput="this.value=
                !!this.value && Math.abs(this.value)>= 0 ? Math.abs(this.value):
              null"
                pInputText
                type="text"
              />
            </span>
          </div>
          <div class="row3 col1">
            <p>
              <b>(b) Deductions.</b>&nbsp;If you expect to claim deductions other than the standard
              deduction and want to reduce your withholding, use the Deductions Worksheet on page 3
              and enter the result here
            </p>
          </div>
          <div class="row3 col2">
            <span><b>4(b) . . . . . . . .</b></span>
          </div>
          <div class="row3 col3">
            <fa-icon [icon]="faCaretRight"></fa-icon>
          </div>
          <div class="row3 col4">
            <span class="p-fluid">
              <input
                [disabled]="true"
                [(ngModel)]="driverW4Update.federalInfo.deductionsAmount"
                min="0"
                oninput="this.value=
                !!this.value && Math.abs(this.value)>= 0 ?
              Math.abs(this.value):null"
                pInputText
                type="text"
              />
            </span>
          </div>
          <div class="row4 col1">
            <p>
              <b>(c) Extra withholding.</b>&nbsp;Enter any additional tax you want withheld each pay
              period
            </p>
          </div>
          <div class="row4 col2">
            <span><b>4(c) . . . . . . . .</b></span>
          </div>
          <div class="row4 col3">
            <fa-icon [icon]="faCaretRight"></fa-icon>
          </div>
          <div class="row4 col4">
            <span class="p-fluid">
              <input
                [(ngModel)]="driverW4Update.federalInfo.aditionallWithholdingAmount"
                min="0"
                oninput="this.value=
                !!this.value && Math.abs(this.value)>= 0 ? Math.abs(this.value):
              null"
                pInputText
                placeholder="$0.00"
                type="number"
              />
            </span>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="Step 5: State Withholding and Signature" [selected]="true">
        <div class="p-grid">
          <div class="p-col-12">
            <b>State Withholdings</b>
          </div>
          <div class="p-col-12">
            <span>Withholding Status</span>
          </div>
          <div class="p-lg-4 p-md-8 p-col-12">
            <span class="p-fluid">
              <p-dropdown
                [(ngModel)]="driverW4Update.stateWithholding.stateWithholding"
                [options]="stateStatus"
                placeholder="Select Withholding Status"
                #withholdiginStatus="ngModel"
              ></p-dropdown>
            </span>
            <div
              *ngIf="driverW4Update.stateWithholding.stateWithholding == ''"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="driverW4Update.stateWithholding.stateWithholding == ''">
                <span>Withholding Status is required.</span>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <span>Number of Dependents</span>
          </div>
          <div class="p-lg-4 p-md-8 p-col-12">
            <span class="p-fluid">
              <input
                [(ngModel)]="driverW4Update.stateWithholding.stateDependents"
                min="0"
                oninput="this.value=
                !!this.value && Math.abs(this.value)>= 0 ? Math.abs(this.value):
              null"
                pInputText
                type="number"
              />
            </span>
          </div>
          <div class="p-col-12">
            <span>Additional Withholding Amount</span>
          </div>
          <div class="p-lg-4 p-md-8 p-col-12">
            <span class="p-fluid">
              <input
                [(ngModel)]="driverW4Update.stateWithholding.stateAdditionallWithholdingAmount"
                min="0"
                oninput="this.value=
                !!this.value && Math.abs(this.value)>= 0 ? Math.abs(this.value):
              null"
                pInputText
                placeholder="$0.00"
                type="number"
              />
            </span>
          </div>
          <div *ngIf="showCalculation" class="p-col-12">
            <span>Alternate Calculation Code</span>
          </div>
          <div *ngIf="showCalculation" class="p-lg-4 p-md-8 p-col-12">
            <span class="p-fluid">
              <p-dropdown
                [(ngModel)]="driverW4Update.stateWithholding.alternateCalculationCode"
                [options]="calculationCodes"
                placeholder="Select Alternate Calculation Code"
                #withholdiginStatus="ngModel"
              ></p-dropdown>
            </span>
            <div
              *ngIf="driverW4Update.stateWithholding.alternateCalculationCode == ''"
              class="alert alert-danger alert-danger-custom"
            >
              <div *ngIf="driverW4Update.stateWithholding.alternateCalculationCode == ''">
                <span>Alternate Calculation Code is required.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <hr />
            <p><b>Signature</b></p>
          </div>
          <div class="p-col-12">
            <span>
              <p-checkbox [binary]="true" [(ngModel)]="isSignedForm" required="true"></p-checkbox>
              By selecting this check box, you are signing this W-4 electronically. You agree your
              electronic signature is the legal equivalent of your manual signature on this W-4.
            </span>
            <br />
            <span>
              <p-checkbox [binary]="true" [(ngModel)]="isDeclaredForm" required="true"></p-checkbox>
              Under penalties of perjury, I declare that I have examined this certificate and, to
              the best of my knowledge and belief, it is true, correct, and complete.
            </span>
            <br />
          </div>
          <div class="p-col-12">
            <button
              (click)="saveEmployee()"
              [disabled]="!isFormValid()"
              label="Sign and Continue"
              pButton
              type="button"
            ></button>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>

<p-confirmDialog
  #cd
  header="Confirmation"
  key="returnToPortal"
  icon="pi
  pi-info-circle"
>
  <p-footer>
    <button type="button" pButton label="Continue to Portal" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-confirmDialog #ed header="Error" key="notSaved" icon="pi pi-info-circle">
  <p-footer>
    <button type="button" pButton label="Close" (click)="ed.accept()"></button>
  </p-footer>
</p-confirmDialog>
